<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <el-button type="primary" size="small" @click="getList">刷新</el-button>
        </li>
        <li>
          <span>开始日期：</span>
          <el-date-picker v-model="startDay" type="date" placeholder="选择日期" size="small" format="yyyy-MM-dd" value-format="yyyyMMdd" :clearable="false" @change="myOption.restStartPage();getList();"></el-date-picker>
        </li>
        <li>
          <span>结束日期：</span>
          <el-date-picker v-model="endDay" type="date" placeholder="选择日期" size="small" format="yyyy-MM-dd" value-format="yyyyMMdd" :clearable="false" @change="myOption.restStartPage();getList();"></el-date-picker>
        </li>
        <li>
          <span>动作类型：</span>
          <el-select size="small" v-model="actionType" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in myOption.actionType" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
        <li>
          <span>REQUEST_ID：</span>
          <el-input size="small" v-model="requestId" @input="getList"></el-input>
        </li>
        <li>
          <span>IMEI：</span>
          <el-input size="small" v-model="imei" @input="getList"></el-input>
        </li>
        <li>
          <span>IMEI_MD5：</span>
          <el-input size="small" v-model="imeiMd5" @input="getList"></el-input>
        </li>
        <li>
          <span>OAID：</span>
          <el-input size="small" v-model="oaid" @input="getList"></el-input>
        </li>
        <li>
          <span>ANDROID_ID：</span>
          <el-input size="small" v-model="androidId" @input="getList"></el-input>
        </li>
        <li>
          <span>ANDROID_ID_MD5：</span>
          <el-input size="small" v-model="androidIdMd5" @input="getList"></el-input>
        </li>
        <li>
          <span>代码位ID：</span>
          <el-input size="small" v-model="slotId" @input="getList"></el-input>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column prop="__time__" label="时间" min-width="180px" fixed="left"></el-table-column>
        <el-table-column prop="app_name" label="广告名称" min-width="150px"></el-table-column>
        <el-table-column prop="bid_type" label="竞价类型" min-width="120px"></el-table-column>
        <el-table-column prop="simulate_bid" label="消耗（元）" min-width="120px"></el-table-column>
        <el-table-column prop="action_type" label="动作类型" min-width="130px"></el-table-column>
        <el-table-column prop="request_id" label="REQUEST_ID" min-width="300px"></el-table-column>
        <el-table-column prop="imei" label="IMEI" min-width="200px"></el-table-column>
        <el-table-column prop="imei_md5" label="IMEI_MD5" min-width="200px"></el-table-column>
        <el-table-column prop="oaid" label="OAID" min-width="140px"></el-table-column>
        <el-table-column prop="oaid_md5" label="OAID_MD5" min-width="140px"></el-table-column>
        <el-table-column prop="android_id" label="ANDROID_ID" min-width="200px"></el-table-column>
        <el-table-column prop="android_id_md5" label="ANDROID_ID_MD5" min-width="200px"></el-table-column>
        <el-table-column prop="slot_id" label="代码位ID" min-width="200px"></el-table-column>
        <el-table-column prop="api_version" label="API版本" min-width="120px"></el-table-column>
        <el-table-column prop="ua" label="UA" min-width="600px"></el-table-column>
        <el-table-column prop="ip" label="IP" min-width="200px"></el-table-column>
        <el-table-column prop="province" label="省份" min-width="120px"></el-table-column>
        <el-table-column prop="city" label="城市" min-width="120px"></el-table-column>
        <el-table-column prop="district" label="区县" min-width="120px"></el-table-column>
        <el-table-column prop="longitude" label="经度" min-width="120px"></el-table-column>
        <el-table-column prop="latitude" label="纬度" min-width="120px"></el-table-column>
        <el-table-column prop="device_type" label="设备类型" min-width="120px"></el-table-column>
        <el-table-column prop="mccmnc" label="运营商" min-width="120px"></el-table-column>
        <el-table-column prop="vendor" label="品牌" min-width="120px"></el-table-column>
        <el-table-column prop="model" label="机型" min-width="120px"></el-table-column>
        <el-table-column prop="os_version" label="操作系统版本" min-width="120px"></el-table-column>
        <el-table-column prop="os_type" label="操作系统类型" min-width="120px"></el-table-column>
        <el-table-column prop="conn_type" label="设备的网络类型" min-width="120px"></el-table-column>
        <el-table-column prop="mac" label="MAC" min-width="150px"></el-table-column>
        <el-table-column prop="dpi" label="屏幕密度" min-width="120px"></el-table-column>
        <el-table-column prop="screen_width" label="设备屏宽" min-width="120px"></el-table-column>
        <el-table-column prop="screen_height" label="设备屏高" min-width="120px"></el-table-column>
        <el-table-column prop="wifi_name" label="WIFI名称" min-width="120px"></el-table-column>
        <el-table-column prop="wifi_mac" label="MAC地址" min-width="140px"></el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
export default {
  name: 'Report',
  components: {
    Pagination
  },
  data () {
    return {
      isLoading: false,
      thisModule: [],
      tableData: [],
      startDay: this.myOption.getNowDateYMD(),
      endDay: this.myOption.getNowDateYMD(),
      actionType: '',
      requestId: '',
      imei: '',
      imeiMd5: '',
      androidId: '',
      androidIdMd5: '',
      slotId: '',
      oaid: ''
    }
  },
  created () {
    // 缓存模块配置
    this.thisModule = this.myOption.requestModule.logStream.children.report
    this.getList()
  },
  methods: {
    // 获取列表
    getList () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.api,
        data: this.qs.stringify({
          from: this.myOption.getNowDateStamp(this.startDay, true),
          to: this.myOption.getNowDateStamp(this.endDay, false),
          offset: (this.$store.state.user.currentPage - 1) * this.$store.state.user.pageSize,
          lines: this.$store.state.user.pageSize,
          reverse: true,
          action_type: this.actionType,
          request_id: this.requestId,
          imei: this.imei,
          imei_md5: this.imeiMd5,
          android_id: this.androidId,
          android_id_md5: this.androidIdMd5,
          slot_id: this.slotId,
          oaid: this.oaid
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          let data = res.data.data.logs || []
          for (let val of data) {
            val.__time__ = this.myOption.writeCurrentDate(val.__time__)
            val.action_type = this.myOption.getIdData('actionType', val.action_type, 'name')
            val.device_type = this.myOption.getIdData('deviceType', val.device_type, 'name')
            val.os_type = this.myOption.getIdData('osType', val.os_type, 'name')
            val.conn_type = this.myOption.getIdData('connType', val.conn_type, 'name')
            val.bid_type = this.myOption.getIdData('bidType', val.bid_type, 'name')
          }
          this.tableData = data
          this.$store.dispatch('SetPageTotal', res.data.data.count)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
  .List-headr li {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/log_stream/Report.vue